import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { TransitionMotion, presets, Motion, spring } from 'react-motion';
import _ from 'lodash';
import { Draggable, Droppable } from '@atlaskit/pragmatic-drag-and-drop-react-beautiful-dnd-migration';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './ApplicationDragContainer.scss';
import ApplyCard from '../../components/ApplyCard';
import { ApplyDefault, ApplyMobile } from '../../utils/mediaQueries';
import Button from '../../components/Button';
/* eslint-disable import/no-named-as-default */
import { Default, Mobile } from '../../utils/mediaQueries';
import {customisedIntlFormatMessage} from '../../utils/helpers';
import AutocompleteField from '../../components/AutocompleteField';
import { exportnewApplicationDragDrop, groupUpdateApplicationRank } from '../../actions/updateApplicationRank';
import { getSavedProgramsAutocomplete } from '../../actions/autocomplete';
import { addNewSchoolApplication, saveApplication } from '../../actions/saveApplication';
import { getStudentApplications } from '../../actions/student';
import { getSchoolsPrograms } from '../../actions/schools';
import messages from '../../locale/messages';
import withRtl from '../../components/hoc/Rtl';
import CaretDownIcon from '../icons/CaretDown';
import CaretUpIcon from '../icons/CaretUp';
import analytics from '../../services/analytics';

function reinsert(arr, from, to) {
  const arr1 = arr.slice(0);
  const val = arr1[from];
  arr1.splice(from, 1);
  arr1.splice(to, 0, val);
  return arr1;
}

function clamp(n, min, max) {
  return Math.max(Math.min(n, max), min);
}

const KEYS = {
  up: 'ArrowUp',
  down: 'ArrowDown',
  tab: 'Tab',
  space: ' ',
  enter: 'Enter',
};

const localMessages = defineMessages({
  applicationdragcontainerHeader: {
    id: 'applicationdragcontainer.Header',
    defaultMessage: 'Your Application',
    description: 'Header for the drag and drop application container',
  },
  emptyApplicationMessage: {
    id: 'applicationdragcontainer.EmptyApplicationMessage',
    defaultMessage: 'Drop Programs Here',
    description: 'Header for the drag and drop application container',
  },
  applicationExplanatoryTextMoreIsBetter: {
    id: 'applicationdragcontainer.ExplanatoryTextMoreIsBetter',
    defaultMessage: 'You can add up to {maxPrograms} programs. More is better!',
    description: 'Explanatory text for applications drag and drop, number of programs',
  },
  applicationExplanatoryTextMoreIsBetterSHS: {
    id: 'applicationdragcontainer.ExplanatoryTextMoreIsBetterSHS',
    defaultMessage: 'You can add up to {maxPrograms} programs. More is better!',
    description: 'Explanatory text for applications drag and drop, number of programs',
  },
  applicationExplanatoryTextMoreIsBetterMSR2: {
    id: 'applicationdragcontainer.ExplanatoryTextMoreIsBetterMSR2',
    defaultMessage: 'You can add up to {maxPrograms} programs.',
    description: 'Explanatory text for applications drag and drop, number of programs, for MSR2 admissions',
  },
  applicationExplanatoryTextMoreIsBetterLG: {
    id: 'applicationdragcontainer.ExplanatoryTextMoreIsBetterLG',
    defaultMessage: 'You can add up to {maxPrograms} programs. More is better!',
    description: 'Explanatory text for applications drag and drop, number of programs',
  },
  applicationdragcontainerReviewBeforeSubmission: {
    id: 'applicationdragcontainer.ReviewBeforeSubmission',
    defaultMessage: 'You’ll have a chance to view your list before submitting it.',
    description: 'Tell the user they can review bfore they do so',
  },
  applicationApplyPageRemoveProgramBeforeSubmissionMessage: {
    id: 'applicationdragcontainer.ApplyPageRemoveProgramBeforeSubmissionMessage',
    defaultMessage: 'NOTE: You must re-submit the application if editing programs after previous submission in order to update the application.',
    description: 'Tell the user they need to submit the app if any program is removed',
  },
});

const springConfig = { stiffness: 300, damping: 50 };

class ApplicationDragContainer extends Component {
  static propTypes = {
    goToApplicationReview: PropTypes.func.isRequired,
    autocomplete: PropTypes.shape({
      savedPrograms: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    handleProgramClick: PropTypes.func.isRequired,
    showPopupContent: PropTypes.func.isRequired,
    saveProgramFunc: PropTypes.func.isRequired,
    normalSchools: PropTypes.shape(),
    user: PropTypes.shape({
      maxPrograms: PropTypes.number.isRequired,
      applicationId: PropTypes.string,
      address: PropTypes.string,
      firstName: PropTypes.string,
      isMS: PropTypes.bool.isRequired,
      isRound2: PropTypes.bool.isRequired,
      isEL: PropTypes.bool.isRequired,
      isLG: PropTypes.bool.isRequired,
      isNS: PropTypes.bool.isRequired,
      isENS: PropTypes.bool.isRequired,
      isSR: PropTypes.bool.isRequired,
      subsidyEligibilityURL: PropTypes.string.isRequired,
      studentApplications: PropTypes.shape({
        entities: PropTypes.shape({
          application: PropTypes.shape({}),
        }),
        results: PropTypes.array.isRequired,
        isMS: PropTypes.bool.isRequired,
        isRound2: PropTypes.bool.isRequired,
      }),
    }).isRequired,
    updateApplicationRank: PropTypes.func.isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string,
    }).isRequired,
    submitDisabledMessage: PropTypes.string,
    canSubmitApplication: PropTypes.bool.isRequired,
    onAutocompleteBlur: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    exportnewApplicationDragDrop: PropTypes.func.isRequired,
    storeProgramRanking: PropTypes.func,
  };

  static contextTypes = {
    intl: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    normalSchools: null,
    autocomplete: {
      savedPrograms: [],
    },
    submitDisabledMessage: null,
    storeProgramRanking: () => { },
  };

  constructor(props) {
    super(props);
    this.state = {
      topDeltaY: 0,
      mouseY: 0,
      isPressed: false,
      originalPosOfLastPressed: 0,
      showSearch: false,
      keyboardSelectedProgram: null,
      searchProgramsValue: '',
      activatedCard: ''
    };

    this.initialKeyboardSelectedIndex = null;
    this.currentKeyboardSelectedIndex = null;
  }

  componentDidMount() {
    window.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    window.addEventListener('touchend', this.handleMouseUp);
    window.addEventListener('mousemove', this.handleMouseMove);
    window.addEventListener('mouseup', this.handleMouseUp);
  }

  componentWillReceiveProps(nextProps) {
    // if a program is removed from the left, reset the keyboard selection
    if (this.props.user.studentApplications.results.length > nextProps.user.studentApplications.results.length) {
      this.resetKeyboardSelection();
    }
  }

  handleTouchStart = (key, pressLocation, e) => {
    this.handleMouseDown(key, pressLocation, e.touches[0]);
  };

  handleTouchMove = e => {
    const { isPressed } = this.state;
    if (isPressed) {
      e.preventDefault();
      e.stopPropagation();
      this.handleMouseMove(e.touches[0]);
    }
  };

  handleMouseDown = (pos, pressY, { pageY }) => {
    const { user } = this.props;
    if (!user.isLG) {
      this.setState({
        ...this.state,
        topDeltaY: pageY - pressY - 100 * pressY,
        mouseY: pressY,
        isPressed: true,
        originalPosOfLastPressed: pos,
      });
    }
  };

  handleMouseMove = event => {
    const { isPressed, topDeltaY, originalPosOfLastPressed } = this.state;
    const { isLG } = this.props.user.isLG;
    const { pageY } = event;
    const { results } = this.props.user.studentApplications;
    let rowPosition = 0;
    if (isPressed && !isLG) {
      // event.preventDefault();
      const mouseY = pageY - topDeltaY;
      let currentRow = results[clamp(Math.round(mouseY / 146), 0, results.length - 1)];
      currentRow = results.indexOf(currentRow);
      this.previewNewProgramRanking(results.indexOf(originalPosOfLastPressed), currentRow);
      rowPosition = currentRow * 146;
      this.setState({
        ...this.state,
        mouseY: mouseY - rowPosition,
      });
    }
  };

  handleMouseUp = event => {
    const { isLG } = this.props.user.isLG;
    if (!isLG) {
      if (this.state.isPressed && !event.target.className.includes('program-remove')) {
        this.storeProgramRanking();
      }
      this.setState({
        ...this.state,
        isPressed: false,
        topDeltaY: 0,
      });
    }
  };

  previewNewProgramRanking = (currentRow, newRow) => {
    const { results } = this.props.user.studentApplications;
    const newOrder = reinsert(results, currentRow, newRow);
    if (newRow !== currentRow) {
      this.props.exportnewApplicationDragDrop(newOrder);
    }
  };

  storeProgramRanking = () => {
    const { dispatch } = this.props;
    const { results } = this.props.user.studentApplications;
    const { application } = this.props.user.studentApplications.entities;
    const y = results.map((id, index) => ({
      id: application[id].id,
      rank: index + 1,
    }));
    return dispatch(groupUpdateApplicationRank(y));
  };

  handleLooProgramAddToApplicationAction = (is_added, programId, schoolId) => {
    let school = this.props.normalSchools.entities.school[schoolId];
    let programData = school.programs.entities.program[programId];
    const { program, directory_school_dbn, directory_school_name } = programData;
    const { code, name } = program;
    let dataDictionary = {
      programName: `${name}`,
      programCode: `${code}`,
      schoolName: `${directory_school_name}`,
      schoolDbn: `${directory_school_dbn}`,
      loggedIn: true
    };
    if(this.props.user.show_loo_tooltip){
      const { loo_chances } = programData;
      dataDictionary['looIndicator'] = loo_chances || 'NOT_AVAIL_PROB';
    }
    analytics({
      eventLabel: is_added ? 'programAdded' : 'programRemoved',
      dataDictionary: dataDictionary,
    });
  }

  saveApplicationFunc = (id, schoolId, savedApplication, savedApplicationId) => {
    const { dispatch } = this.props;
    // Checks to see if program has been deleted then reranks and saves application order.
    dispatch(saveApplication(id, schoolId, '', savedApplication, savedApplicationId)).then((status) => {
      if(status == 'ADD_TO_APPLICATION_SUCCESS'){
        this.handleLooProgramAddToApplicationAction(true, id, schoolId);
      }
      if(status == 'REMOVE_FROM_APPLICATION_SUCCESS'){
        this.handleLooProgramAddToApplicationAction(false, id, schoolId);
      }
      this.storeProgramRanking();
      return true;
    });

    return true;
  };

  getItemStyle = (isDragging, draggableStyle) => ({
    opacity: isDragging ? '.75' : '1',
    paddingBotton: '20px',
    // styles we need to apply on draggables
    ...draggableStyle,
  });

  handleSaveApplication = (id, schoolId, schoolDbn, savedApplication, savedApplicationId) => {
    const { normalSchools, showPopupContent, dispatch } = this.props;
    // Check if school has not been saved
    let need_to_save = !_.includes(normalSchools.result, schoolId);
    // Check if program has not been saved
    if(!need_to_save){
      need_to_save = !_.includes(normalSchools.entities.school[schoolId].programs.result, id);
    }
    if (need_to_save) {
      dispatch(addNewSchoolApplication(id, schoolId, schoolDbn, savedApplication, savedApplicationId)).then(() => {
        this.handleLooProgramAddToApplicationAction(true, id, schoolId);
        this.props.storeProgramRanking();
      });
      // showPopupContent(`Program added to you application.  We've also saved it for you.`, this.pageX, this.pageY);
      showPopupContent({
        children: `Program added to you application. We've also saved it for you.`,
        // top: this.pageX,
        // left: this.pageY,
      });
      return true;
    }
    dispatch(saveApplication(id, schoolId, schoolDbn, savedApplication, savedApplicationId)).then((status) => {
      if(status == 'ADD_TO_APPLICATION_SUCCESS'){
        this.handleLooProgramAddToApplicationAction(true, id, schoolId);
      }
      if(status == 'REMOVE_FROM_APPLICATION_SUCCESS'){
        this.handleLooProgramAddToApplicationAction(false, id, schoolId);
      }
      this.props.storeProgramRanking();
    });
    return true;
  };

  willEnter = () => ({
    width: 0,
    // maxHeight: 0,
    opacity: 0,
  });

  willLeave = () => ({
    width: spring(0),
    // maxHeight: spring(0),
    opacity: spring(0),
  });

  //  schoolListItem = (rank, id, programId, className );

  handleApplicationSearchClick = () => {
    this.setState({
      ...this.state,
      showSearch: true,
    });
  };

  handleApplicationSearchKeyDown = event => {
    const tabWithoutShift = !event.shiftKey && event.key === 'Tab';
    const shiftAloneOrWithTab = event.shiftKey && (event.key === 'Tab' || event.key === 'Shift');
    if (tabWithoutShift || shiftAloneOrWithTab) {
      return;
    }

    this.handleApplicationSearchClick();
  };

  handleKeyDown = (event, value = null) => {
    const { dispatch } = this.props;
    const searchProgramsValue = value !== null ? value : event.target.value;
    this.setState({
      ...this.state,
      searchProgramsValue,
    });

    dispatch(getSavedProgramsAutocomplete(searchProgramsValue));
  };

  goToApplicationReview = () => {
    const { origin, pathname } = window.location;
    const normalizedPath = pathname.endsWith('/') ? pathname : `${pathname}/`;
    const reviewUrl = new URL('review', `${origin}${normalizedPath}`);
    window.location.assign(reviewUrl.toString());
  };

  resetKeyboardSelection = () => {
    this.initialKeyboardSelectedIndex = null;
    this.currentKeyboardSelectedIndex = null;
    this.setState({
      ...this.state,
      keyboardSelectedProgram: null,
    });
  };

  applicationKeyboardSelected = (programId, event) => {
    if ([KEYS.up, KEYS.down, KEYS.space].includes(event.key)) {
      event.preventDefault();
      event.stopPropagation();
    }
    const { keyboardSelectedProgram } = this.state;
    const { results } = this.props.user.studentApplications;
    const lastIndex = results.length - 1;
    const selectedIndex = results.indexOf(programId);

    if (keyboardSelectedProgram) {
      if (event.key === KEYS.up || event.key === KEYS.down) {
        const currentRow = selectedIndex;
        let newRow = currentRow + (event.key === KEYS.up ? -1 : 1);
        if (newRow < 0) {
          newRow = 0;
        } else if (newRow >= lastIndex) {
          newRow = lastIndex;
        }
        this.currentKeyboardSelectedIndex = newRow;
        this.previewNewProgramRanking(currentRow, newRow);
      } else if (event.key === ' ') {
        if (this.initialKeyboardSelectedIndex !== this.currentKeyboardSelectedIndex) {
          this.storeProgramRanking();
        }
        this.resetKeyboardSelection();
      }
    } else if (event.key === ' ') {
      this.initialKeyboardSelectedIndex = selectedIndex;
      this.currentKeyboardSelectedIndex = selectedIndex;
      this.setState({
        ...this.state,
        keyboardSelectedProgram: programId,
      });
    }
  };

  handleAutocompleteBlur = () => {
    const { onAutocompleteBlur } = this.props;

    // this.props.clearSavedProgramsAutocomplete();

    if (this.state.searchProgramsValue === '') {
      this.setState({
        ...this.state,
        showSearch: false,
      });
    }

    onAutocompleteBlur();
  };

  handleProgramKeyDown = (programId, id, event) => {
    // Prevent wrong focusing when using tab to navigate through application drag container
    if (event.key !== 'Enter') {
      return;
    }
    this.props.handleProgramClick(programId, id);
  };

  handleSubmitClick = location => {
    const { dispatch, user: { isEL, subsidyEligibilityURL } } = this.props;

    this.storeProgramRanking().then(() => {
      if (isEL) {
        window.location = subsidyEligibilityURL;
        return;
      }
      this.props.goToApplicationReview(location).then(deletedPrograms => {
        if (deletedPrograms) {
          // Request for getting alerts might remove some application programs so storeProgramRanking must be called again
          dispatch(getStudentApplications(this.props.user.applicationId)).then(() => this.storeProgramRanking());
          dispatch(getSchoolsPrograms());
        }
      });
    });
  };

  handleArrowClick = async (oldRank, newRank) => {
    await this.previewNewProgramRanking(oldRank, newRank);
    this.storeProgramRanking();
  };

  renderApplicationMotion = (programId, id, rank) => {
    const { updateApplicationRank, handleProgramClick, user } = this.props;
    const { mouseY, isPressed, originalPosOfLastPressed, keyboardSelectedProgram } = this.state;
    const motionStyle =
      originalPosOfLastPressed === programId && isPressed
        ? {
          scale: spring(1.05, springConfig),
          shadow: spring(16, springConfig),
          y: mouseY,
        }
        : {
          scale: spring(1, springConfig),
          shadow: spring(0, springConfig),
          y: spring(user.studentApplications.results.indexOf(programId) * 1.46, springConfig),
        };

    let opacity = 1;
    if (keyboardSelectedProgram && keyboardSelectedProgram !== programId) {
      opacity = 0.5;
    }
    return (
      <Motion style={motionStyle}>
        {({ scale, shadow, y }) => (
          <div
            /* eslint-disable react/jsx-no-bind */
            role="listbox"
            tabIndex="0"
            onMouseDown={this.handleMouseDown.bind(null, programId, y)}
            onTouchStart={this.handleTouchStart.bind(null, programId, y)}
            onKeyDown={event => this.applicationKeyboardSelected(programId, event)}
            style={{
              boxShadow: `rgba(0, 0, 0, 0.2) 0px ${shadow}px ${2 * shadow}px 0px`,
              transform: `translate3d(0, ${Math.round(y)}px, 0) scale(${scale})`,
              WebkitTransform: `translate3d(0, ${Math.round(y)}px, 0) scale(${scale})`,
              zIndex: programId === originalPosOfLastPressed ? 99 : 1,
            }}
          >
            <div rank={rank} key={`${id}-${programId}`} className={style.applicationListItem}>
              {/* * Keydown is a placeholder for functional keydown * */}
              <div style={{ opacity }}>
                {user.studentApplications.entities.application[programId] && (
                  <ApplyCard
                    onClick={() => handleProgramClick(programId, id)}
                    onKeyDown={e => this.handleProgramKeyDown(programId, id, e)}
                    rank={rank}
                    id={programId}
                    {...user.studentApplications.entities.application[programId]}
                    updateApplicationRank={updateApplicationRank}
                    removeProgram={this.saveApplicationFunc}
                    firstName={user.firstName}
                    user={user}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </Motion>
    );
  };

  renderApplicationPlaceholder = () => {
    const { autocomplete, user } = this.props;
    const { isSHS, isLG, isMS, isNS, isENS, isRound2, maxPrograms } = user;
    const isMSR2 = isMS && isRound2;
    return (
      <>
        {!isLG && (
          <div className={this.state.activatedCard != '' ? style.searchFieldOnTooltipActivated + ' ' + style.searchField : style.searchField}>
            <AutocompleteField
              onChangeValue={this.handleKeyDown}
              title="Other Programs"
              saveApplication={this.handleSaveApplication}
              options={autocomplete.savedPrograms}
              onBlur={this.handleAutocompleteBlur}
              user={this.props.user}
            />
            {maxPrograms && (
              <div className={style.explanatoryTextSmall}>
                {isMSR2 && <FormattedMessage
                  {...localMessages.applicationExplanatoryTextMoreIsBetterMSR2}
                  values={{maxPrograms}}
                />}
                {isLG && <FormattedMessage
                  {...localMessages.applicationExplanatoryTextMoreIsBetterLG}
                  values={{maxPrograms}}
                />}
                {isSHS && <FormattedMessage
                  {...localMessages.applicationExplanatoryTextMoreIsBetterSHS}
                  values={{maxPrograms}}
                />}
                {!isMSR2 && !isSHS && !isLG && maxPrograms && <FormattedMessage
                  {...localMessages.applicationExplanatoryTextMoreIsBetter}
                  values={{maxPrograms}}
                />}
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  onMouseLeave = (programId) => {
    if(this.state.activatedCard === programId){
      this.setState({
        ...this.state,
        activatedCard: ''
      })
    }
  }

  onMouseEnter = (programId) => {
    this.setState({
      ...this.state,
      activatedCard: programId
    })
  }

  renderApplicationPrograms = (interpolatedStyles) => {
    const { user } = this.props;
    const { isLG, isMS, isRound2 } = user;
    return (
      interpolatedStyles.map((config, index) => {
        const { id, programId, rank } = config.data;
        return (
          <div className={style.programItemContainer} key={programId}>
            {!isLG && (<span className={style.itemNumber}>
              {index !== 0 && (
                <CaretUpIcon
                  fill="#024cbc"
                  size="18px"
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    padding: '3px',
                    cursor: 'pointer',
                  }}
                  onClick={() => this.handleArrowClick(index, index - 1)}
                />
              )}
              {index + 1}
              {index !== interpolatedStyles.length - 1 && (
                <CaretDownIcon
                  fill="#024cbc"
                  size="18px"
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    padding: '3px',
                    cursor: 'pointer',
                  }}
                  onClick={() => this.handleArrowClick(index, index + 1)}
                />
              )}
            </span>
          )}
          <div key={programId}>{this.renderApplicationMotion(programId, id, rank)}</div>
        </div>
      );
      })
    )
  };

  renderApplicationProgramsForDefault = (interpolatedStyles) => {
    const { user } = this.props;
    const { isLG } = user;
    return (
      interpolatedStyles.map((config, index) => {
        const { id, programId, rank, applicationId } = config.data;
        return (
          <div
            onMouseLeave={() => this.onMouseLeave(programId)}
            className={this.state.activatedCard === programId ? style.tooltipActivated : ''}
            onMouseEnter={() => this.onMouseEnter(programId)}
          >
            <Draggable
            key={programId}
            draggableId={JSON.stringify({
              programId: programId,
              schoolId: id,
              savedApplicationId: +applicationId,
            })}
            index={index}
            type="PROGRAM"
            isDragDisabled={true}
          >
            {(provided, snapshot) => (
              <div
                className={style.listApplyItem}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={this.getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
              >
                <div className={style.programItemContainer} key={programId}>
                  {!isLG && (<span className={style.itemNumber}>
                    {index !== 0 && (
                      <CaretUpIcon
                        fill="#024cbc"
                        size="18px"
                        style={{
                          backgroundColor: '#fff',
                          borderRadius: '50%',
                          padding: '3px',
                          cursor: 'pointer',
                        }}
                        onClick={() => this.handleArrowClick(index, index - 1)}
                      />
                    )}
                    {index + 1}
                    {index !== interpolatedStyles.length - 1 && (
                      <CaretDownIcon
                        fill="#024cbc"
                        size="18px"
                        style={{
                          backgroundColor: '#fff',
                          borderRadius: '50%',
                          padding: '3px',
                          cursor: 'pointer',
                        }}
                        onClick={() => this.handleArrowClick(index, index + 1)}
                      />
                    )}
                  </span>)}
                  <div className={style.itemContainer} key={programId}>
                    <div rank={rank} key={`${id}-${programId}`} className={style.applicationListItem}>
                      {/* * Keydown is a placeholder for functional keydown * */}
                      {user.studentApplications.entities.application[programId] && (
                        <div key={programId}>{this.renderApplicationMotion(programId, id, rank)}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Draggable>
          </div>
        );
      })
    );
  };

  renderApplications = () => {
    const { autocomplete, user } = this.props;
    const { isSHS, isLG, isMS, isRound2, maxPrograms } = user;
    const { results, entities } = this.props.user.studentApplications;
    const applicationListItemWidth = window.innerWidth >= 768 ? 360 : 270;
    const isMSR2 = isMS && isRound2;

    let load = null;
    let programListDefault = null;
    let programListMobile = null;

    const programList = results.map(programId => ({
      applicationId: entities.application[programId].application,
      id: entities.application[programId].directory_program.directory_school_id,
      programId,
      rank: results.indexOf(programId),
    }));

    if (programList.length === 0) {
      load = (
        <>
          <ApplyMobile>
            <div className={style.placeholder}>
              <FormattedMessage {...localMessages.emptyApplicationMessage} />
            </div>
            {this.renderApplicationPlaceholder()}
          </ApplyMobile>
          <ApplyDefault>
            <Droppable droppableId="droppable-0" type="PROGRAM" isDropDisabled={false} isCombineEnabled={false} ignoreContainerClipping={false}>
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={style.applicationList}
                  style={{
                    backgroundColor: snapshot.isDraggingOver ? 'rgba(255,255,255,0.15)' : 'unset',
                  }}>
                  <div className={style.placeholder}>
                    <FormattedMessage {...localMessages.emptyApplicationMessage} />
                  </div>
                </div>
              )}
            </Droppable>
            {this.renderApplicationPlaceholder()}
          </ApplyDefault>
        </>
      );
    } else if (programList.length !== 0) {
      if ((programList.length < maxPrograms && !isLG) || maxPrograms == null) {
        load = (
          <div className={this.state.activatedCard != '' ? style.searchFieldOnTooltipActivated + ' ' + style.searchField : style.searchField}>
            <AutocompleteField
              onChangeValue={this.handleKeyDown}
              title="Other Programs"
              saveApplication={this.handleSaveApplication}
              options={autocomplete.savedPrograms}
              onBlur={this.handleAutocompleteBlur}
              user={this.props.user}
            />
            {maxPrograms && (
              <div className={style.explanatoryTextSmall}>
                {isMSR2 && <FormattedMessage
                  {...localMessages.applicationExplanatoryTextMoreIsBetterMSR2}
                  values={{maxPrograms}}
                />}
                {isSHS && <FormattedMessage
                  {...localMessages.applicationExplanatoryTextMoreIsBetterSHS}
                  values={{maxPrograms}}
                />}
                {isLG && <FormattedMessage
                  {...localMessages.applicationExplanatoryTextMoreIsBetterLG}
                  values={{maxPrograms}}
                />}
                {!isMSR2 && !isSHS && !isLG && maxPrograms && <FormattedMessage
                  {...localMessages.applicationExplanatoryTextMoreIsBetter}
                  values={{maxPrograms}}
                />}
              </div>
            )}
          </div>
        );
      }
      const interpolatedStyles = programList.map(item => ({
        key: `${item.id}-${item.programId}`,
        style: {
          width: spring(applicationListItemWidth, presets.gentle),
          opacity: spring(1, presets.gentle),
          // maxHeight: spring(446, presets.gentle),
        },
        data: {
          rank: item.rank,
          id: item.id,
          programId: item.programId,
          applicationId: item.applicationId,
        },
      }));
      programListDefault = (
        <div style={{ display: 'flex' }}>
          <ApplyMobile>
            <ol className={style.applicationList}>
              {this.renderApplicationPrograms(interpolatedStyles)}
            </ol>
          </ApplyMobile>
          <ApplyDefault>
            <Droppable droppableId="droppable-0" type="PROGRAM" isDropDisabled={false} isCombineEnabled={false} ignoreContainerClipping={false}>
              {(provided, snapshot) => (
                <div
                  className={style.applicationList}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{
                    backgroundColor: snapshot.isDraggingOver ? 'rgba(255,255,255,0.15)' : 'unset',
                  }}>
                  {this.renderApplicationProgramsForDefault(interpolatedStyles)}
                </div>
              )}
            </Droppable>
          </ApplyDefault>
        </div>
      );

      programListMobile = (
        <TransitionMotion
          willLeave={this.willLeave}
          willEnter={this.willEnter}
          styles={programList.map(item => ({
            key: `${item.id}-${item.programId}`,
            style: {
              width: spring(applicationListItemWidth, presets.gentle),
              opacity: spring(1, presets.gentle),
              // maxHeight: spring(446, presets.gentle),
            },
            data: {
              rank: item.rank,
              id: item.id,
              programId: item.programId,
            },
          }))}
        >
          {interpolatedStyles => (
            <ol className={style.applicationList}>
              {interpolatedStyles.map(config => {
                const { id, programId, rank } = config.data;
                return (
                  <div
                    key={programId}
                    onMouseLeave={() => this.onMouseLeave(programId)}
                    className={this.state.activatedCard === programId ? style.tooltipActivated + ' ' + style.programItemContainer : style.programItemContainer}
                    onMouseEnter={() => this.onMouseEnter(programId)}
                  >
                    <span className={style.itemNumber}>
                      {rank !== 0 && (
                        <CaretUpIcon
                          fill="#024cbc"
                          size="18px"
                          style={{
                            backgroundColor: '#fff',
                            borderRadius: '50%',
                            padding: '3px',
                            cursor: 'pointer',
                          }}
                          onClick={() => this.handleArrowClick(rank, rank - 1)}
                        />
                      )}
                      {rank + 1}
                      {rank !== interpolatedStyles.length - 1 && (
                        <CaretDownIcon
                          fill="#024cbc"
                          size="18px"
                          style={{
                            backgroundColor: '#fff',
                            borderRadius: '50%',
                            padding: '3px',
                            cursor: 'pointer',
                          }}
                          onClick={() => this.handleArrowClick(rank, rank + 1)}
                        />
                      )}
                    </span>
                    <div key={programId}>{this.renderApplicationMotion(programId, id, rank)}</div>
                  </div>
                );
              })}
            </ol>
          )}
        </TransitionMotion>
      );
    }

    const { intl } = this.props;
    const { location } = window;
    return (
      <>
        <div className={style.applicationDragContainer}>
        <Default>{programListDefault}</Default>
        <Mobile>{programListMobile}</Mobile>
        {load}
        </div>
        <div className={style.applicationSidebarFooter}>
          {!this.props.canSubmitApplication && this.props.submitDisabledMessage ? (
            <p className={style.sidebarMessaging}>{this.props.submitDisabledMessage}</p>
          ) : (
            <Fragment>
              <Default>
                <Button
                  onClick={() => this.handleSubmitClick(location)}
                  large
                  full
                  uppercase
                  label={customisedIntlFormatMessage(intl, messages.buttonSchoolsSearchNext)}
                  disabled={!(results.length > 0)}
                  customClass={style.nextButton}
                />
              </Default>
              <Mobile>
                <Button
                  onClick={() => this.handleSubmitClick(location)}
                  label={customisedIntlFormatMessage(intl, messages.buttonSchoolsSearchNext)}
                  disabled={!(results.length > 0)}
                />
              </Mobile>
              <p className={style.sidebarMessaging}>
                <FormattedMessage {...localMessages.applicationdragcontainerReviewBeforeSubmission} />
              </p>
              <p className={style.applicationProgramRemoveMessage}>
                <FormattedMessage {...localMessages.applicationApplyPageRemoveProgramBeforeSubmissionMessage} />
              </p>
            </Fragment>
          )}
        </div>
      </>
    );
  };

  render() {
    return (
      <div className={style.applications}>
          {this.renderApplications()}
      </div>
    );
  }
}

const mapState = ({ user }) => ({
  user,
});

const mapDispatch = {
  exportnewApplicationDragDrop,
};

// We use the injectIntl Higher Order Component (HOC) to make sure the component updates
// Read more about that here https://github.com/yahoo/react-intl/issues/371 and
// https://github.com/yahoo/react-intl/wiki/API#injectintl

export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(mapState, mapDispatch),
)(ApplicationDragContainer);
